(function () {
  var CLOSE_DURATION = 180;

  function closeHotspot(hotspot) {
    hotspot.classList.add('is-closing');
    setTimeout(function () {
      hotspot.classList.remove('is-active', 'is-closing');
    }, CLOSE_DURATION);
  }

  function closeAllHotspots() {
    document.querySelectorAll('.academy-our-bikes__hotspot.is-active').forEach(closeHotspot);
  }

  function positionPopup(hotspot) {
    var popup = hotspot.querySelector('[data-hotspot-popup]');
    if (!popup) return;

    var dot = hotspot.querySelector('[data-hotspot-toggle]');
    var stage = hotspot.closest('.academy-our-bikes__stage');
    var dotSize = dot.offsetWidth;
    var popupWidth = 400;
    var gap = 16;

    var hotspotRect = hotspot.getBoundingClientRect();
    var stageRect = stage
      ? stage.getBoundingClientRect()
      : { left: 0, top: 0, right: window.innerWidth, width: window.innerWidth, height: window.innerHeight };

    // Mobile: center within stage
    if (window.innerWidth < 1024) {
      var mobileWidth = Math.min(360, window.innerWidth - 32);
      popup.style.width = mobileWidth + 'px';
      popup.style.left = (stageRect.left - hotspotRect.left + (stageRect.width - mobileWidth) / 2) + 'px';
      popup.style.top  = (stageRect.top  - hotspotRect.top  + stageRect.height / 2 - 150) + 'px';
      popup.style.transformOrigin = 'top center';
      return;
    }

    popup.style.width = '';

    // Desktop: right of dot by default
    var left = dotSize + gap;
    var top  = -30;

    // Flip to left if popup overflows stage right edge
    if (hotspotRect.left + left + popupWidth > stageRect.right - gap) {
      left = -(popupWidth + gap);
      popup.style.transformOrigin = 'top right';
    } else {
      popup.style.transformOrigin = 'top left';
    }

    // Clamp vertically within stage
    var minTop = stageRect.top - hotspotRect.top + gap;
    if (top < minTop) top = minTop;

    popup.style.left = left + 'px';
    popup.style.top  = top  + 'px';
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hotspot-toggle]');
    var close  = e.target.closest('[data-hotspot-close]');

    if (close) {
      var hotspot = close.closest('.academy-our-bikes__hotspot');
      if (hotspot) closeHotspot(hotspot);
      return;
    }

    if (toggle) {
      var hotspot   = toggle.closest('.academy-our-bikes__hotspot');
      var wasActive = hotspot.classList.contains('is-active');

      closeAllHotspots();

      if (!wasActive) {
        positionPopup(hotspot);
        hotspot.classList.add('is-active');
      }
      return;
    }

    if (!e.target.closest('.academy-our-bikes__popup')) {
      closeAllHotspots();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllHotspots();
  });
})();
